import { GridListTile } from 'pages/Registration/ResponsiveGridList';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, Theme } from '@material-ui/core';
import guestRegisterImage from 'static/img/add-guest-registration.png';

const teal5 = '#f4fafa';

interface GuestRegistrationCardTile {
  isSelected: boolean;
  onSelectGuestRegistration: () => void;
}

const GuestRegistrationTile: React.FunctionComponent<GuestRegistrationCardTile> = (props) => {
  const classes = styles(props);
  const intl = useIntl();
  const { onSelectGuestRegistration, isSelected, ...styleProps } = props;

  return (
    <GridListTile
      {...styleProps}
      name={intl.formatMessage({ id: 'addNewGuestRegistration' })}
      image={guestRegisterImage}
      value={intl.formatMessage({ id: 'addNewGuestRegistration' })}
      onClick={onSelectGuestRegistration}
      isSelected={isSelected}
      className={classes.tile}
    />
  );
};

const styles = makeStyles<Theme, GuestRegistrationCardTile>({
  tile: {
    '& > *': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: teal5,
      padding: '20px 20px 50px 20px'
    },
    '& img': {
      position: 'static',
      transform: 'none',
      paddingTop: '20px',
      width: '120% !important',
      height: 'auto !important'
    }
  }
});

export default GuestRegistrationTile;
